import { useEffect, useState } from "react";
import "./Modal.css";
import { toast } from "react-toastify";

const Modal = ({
  open,
  title,
  initialValues = {},
  fields = [],
  onClose,
  onSubmit,
}) => {
  const [form, setForm] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) return;

    setForm(
      initialValues && Object.keys(initialValues).length > 0
        ? initialValues
        : {},
    );
  }, [open]);

  if (!open) return null;

  const handleChange = (name, value) => {
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    for (let f of fields) {
      if (f.required && !form[f.name]?.trim()) {
        toast.error(`${f.label} is required`);
        return;
      }
    }
    setSubmitting(true);

    try {
      await onSubmit(form);
      onClose();
    } catch (err) {
      toast.error("Something went wrong ❌");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>

        {/* FIELDS */}
        {fields.map((field) => (
          <input
            key={field.name}
            className="modal-input"
            placeholder={field.label}
            value={form[field.name] || ""}
            onChange={(e) =>
              setForm((prev) => ({
                ...prev,
                [field.name]: e.target.value,
              }))
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmit();
              }
            }}
          />
        ))}

        {/* ACTIONS */}
        <div className="modal-actions">
          <button className="btn cancel" onClick={onClose}>
            Cancel
          </button>

          <button
            className="btn save"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
